module.exports = __webpack_public_path__ + "img/ImageNotAvailable.4ed80548.jpg";